import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-charge-stations-edit',
  templateUrl: './charge-stations-edit.component.html',
  styleUrls: ['./charge-stations-edit.component.css']
})
export class ChargeStationsEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
